import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   //访客主页面
    //   path: "/visitor",
    //   name: "/visitor",
    //   component: resolve => require(["../views/mobile/Visitor.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    // {
    //   //访客个人信息页面
    //   path: "/vpersonal",
    //   name: "/vpersonal",
    //   component: resolve => require(["../views/mobile/Vpersonal.vue"], resolve)
    // },
    // {
    //   //访客发起预约
    //   path: "/vreserve",
    //   name: "/vreserve",
    //   component: resolve => require(["../views/mobile/Vreserve.vue"], resolve)
    // },
    // {
    //   //货车预约
    //   path: "/vreservecar",
    //   name: "/vreservecar",
    //   component: resolve =>
    //     require(["../views/mobile/VreserveCar.vue"], resolve)
    // },
    // {
    //   //访客预约凭证列表
    //   path: "/vrecord",
    //   name: "/vrecord",
    //   component: resolve => require(["../views/mobile/Vrecord.vue"], resolve)
    // },
    // {
    //   //货车预约记录列表
    //   path: "/vrecordCar",
    //   name: "/vrecordCar",
    //   component: resolve => require(["../views/mobile/VrecordCar.vue"], resolve)
    // },
    // {
    //   //
    //   path: "/vrecord2",
    //   name: "/vrecord2",
    //   component: resolve => require(["../views/mobile/Vrecord2.vue"], resolve)
    // },
    // {
    //   //访客预约凭证详细信息
    //   path: "/vdetail",
    //   name: "/vdetail",
    //   component: resolve => require(["../views/mobile/Vdetail.vue"], resolve)
    // },
    // {
    //   //货车预约记录详情
    //   path: "/vdetailCar",
    //   name: "/vdetailCar",
    //   component: resolve => require(["../views/mobile/VdetailCar.vue"], resolve)
    // },
    // {
    //   //演示来访预约
    //   path: "/vreserve2",
    //   name: "/vreserve2",
    //   component: resolve => require(["../views/mobile/Vreserve2.vue"], resolve)
    // },
    //
    // {
    //   //错误信息的提示页面
    //   path: "/ErrPage",
    //   name: "/ErrPage",
    //   component: resolve => require(["../views/mobile/ErrPage.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    //
    // {
    //   //模板消息点击页面
    //   path: "/scode",
    //   name: "/scode",
    //   component: resolve => require(["../views/mobile/Scode.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    //
    // {
    //   // 钉钉验证页面
    //   path: "/staff1",
    //   name: "/staff1",
    //   component: resolve => require(["../views/mobile/Staff1.vue"], resolve)
    // },
    //
    // {
    //   //被访人主页面
    //   path: "/staff",
    //   name: "/staff",
    //   component: resolve => require(["../views/mobile/Staff.vue"], resolve)
    // },
    // {
    //   //被访人主页面
    //   path: "/spersonal",
    //   name: "/spersonal",
    //   component: resolve => require(["../views/mobile/Spersonal.vue"], resolve)
    // },
    // {
    //   //被访人邀请访客
    //   path: "/sinvite",
    //   name: "/sinvite",
    //   component: resolve => require(["../views/mobile/Sinvite.vue"], resolve)
    // },
    // {
    //   //被访人预约凭证列表
    //   path: "/srecord",
    //   name: "/srecord",
    //   component: resolve => require(["../views/mobile/Srecord.vue"], resolve)
    // },
    // {
    //   //被访人预约凭证列表 货车预约
    //   path: "/srecordCar",
    //   name: "/srecordCar",
    //   component: resolve => require(["../views/mobile/SrecordCar.vue"], resolve)
    // },
    // {
    //   //被访人预约凭证列表
    //   path: "/srecord2",
    //   name: "/srecord2",
    //   component: resolve => require(["../views/mobile/Srecord2.vue"], resolve)
    // },
    // {
    //   //被访人预约凭证列表
    //   path: "/srecordc",
    //   name: "/srecordc",
    //   component: resolve => require(["../views/mobile/Srecordc.vue"], resolve)
    // },
    // {
    //   //被访人预约凭证详细信息
    //   path: "/sdetail",
    //   name: "/sdetail",
    //   component: resolve => require(["../views/mobile/Sdetail.vue"], resolve)
    // },
    // {
    //   //被访人预约凭证详细信息 货车预约
    //   path: "/sdetailCar",
    //   name: "/sdetailCar",
    //   component: resolve => require(["../views/mobile/SdetailCar.vue"], resolve)
    // },
    // {
    //   //被访人-待审核记录
    //   path: "/Sundo",
    //   name: "/Sundo",
    //   component: resolve => require(["../views/mobile/Sundo.vue"], resolve)
    // },
    //
    // {
    //   // 考试
    //   path: "/VKaoShi",
    //   name: "/VKaoShi",
    //   component: resolve => require(["../views/mobile/VKaoShi.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    // {
    //   // 观看视频
    //   path: "/VVideo",
    //   name: "/VVideo",
    //   component: resolve => require(["../views/mobile/VVideo.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    //
    // {
    //   // 输入身份证号码验证
    //   path: "/VInputIdCard",
    //   name: "/VInputIdCard",
    //   component: resolve =>
    //     require(["../views/mobile/VInputIdCard.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    // {
    //   // 查看考试信息页面
    //   path: "/VInformation",
    //   name: "/VInformation",
    //   component: resolve =>
    //     require(["../views/mobile/VInformation.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    //
    // {
    //   //申请放行条（物流放行）
    //   path: "/Srelease",
    //   name: "/Srelease",
    //   component: resolve => require(["../views/mobile/Srelease.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    // {
    //   //申请放行条(普通)
    //   path: "/SreleasePt",
    //   name: "/SreleasePt",
    //   component: resolve =>
    //     require(["../views/mobile/SreleasePt.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    // {
    //   //放行条记录列表
    //   path: "/SreleaseRecord",
    //   name: "/SreleaseRecord",
    //   component: resolve =>
    //     require(["../views/mobile/SreleaseRecord.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    // {
    //   //放行条记录详情
    //   path: "/SreleaseDetail",
    //   name: "/SreleaseDetail",
    //   component: resolve =>
    //     require(["../views/mobile/SreleaseDetail.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    // {
    //   //保安放行
    //   path: "/SreleaseRegister",
    //   name: "/SreleaseRegister",
    //   component: resolve =>
    //     require(["../views/mobile/SreleaseRegister.vue"], resolve),
    //   meta: { allowBack: false }
    // },
    // {
    //   //保安放行时查看详情
    //   path: "/SreleaseRegisterDetail",
    //   name: "/SreleaseRegisterDetail",
    //   component: resolve =>
    //     require(["../views/mobile/SreleaseRegisterDetail.vue"], resolve),
    //   meta: { allowBack: false }
    // }
    // ,

    {
      //登录页面
      path: "/",
      name: "/",
      component: resolve =>
        require(["../views/car/Login.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //登录页面
      path: "/Login",
      name: "/Login",
      component: resolve =>
        require(["../views/car/Login.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //车牌记录
      path: "/CarRecord",
      name: "/CarRecord",
      component: resolve =>
        require(["../views/car/CarRecord.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //车牌记录
      path: "/CarDetail",
      name: "/CarDetail",
      component: resolve =>
        require(["../views/car/CarDetail.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //生成二维码
      path: "/CarQR",
      name: "/CarQR",
      component: resolve =>
        require(["../views/car/CarQR.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //添加车辆
      path: "/CarCreate",
      name: "/CarCreate",
      component: resolve =>
        require(["../views/car/CarCreate.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //二维码扫码的方式添加车辆
      path: "/CarQrCreate",
      name: "/CarQrCreate",
      component: resolve =>
        require(["../views/car/CarQrCreate.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //二维码扫码的方式添加车辆
      path: "/CarQrCreate33",
      name: "/CarQrCreate33",
      component: resolve =>
        require(["../views/car/CarQrCreate33.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //二维码扫码的方式添加车辆
      path: "/CarQrCreate2",
      name: "/CarQrCreate2",
      component: resolve =>
        require(["../views/car/CarQrCreate2.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //页面空状态
      path: "/CarEmpty",
      name: "/CarEmpty",
      component: resolve =>
        require(["../views/car/CarEmpty.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //页面空状态
      path: "/CarDH",
      name: "/CarDH",
      component: resolve =>
        require(["../views/car/CarDH.vue"], resolve),
      meta: { allowBack: false }
    },

  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js